import { useState, useEffect } from 'react'
import { Grid, Input, Button, Modal } from '@design-systems/canvas-ui'
import { getRfiTagValues } from '../../../common/common'

const radioBtns = [
  { value: 'bypass', label: 'Fasttrack RFI3 Review' },
  { value: 'continue', label: 'Continue RFI3 Review' },
]

const BypassRFI3Modal = (props) => {
  const [commentsMaxLen, setCommentsMaxLen] = useState('500')
  const [comments, setComments] = useState('')
  const [bypassRfi3, setBypassRfi3] = useState(true)

  //#region UseEffect

  useEffect(() => {
    if (props.commentsMaxLen) {
      setCommentsMaxLen(props.commentsMaxLen)
    }
  }, [props.commentsMaxLen])

  //#endregion

  /**
   * Is comments errored - if empty OR if comments >= max permitted
   * @returns
   */
  const isCommentError = () => {
    return comments.length === 0 || comments.length >= commentsMaxLen
  }

  const clearAndCancelModal = () => {
    setComments('')
    setBypassRfi3(true)
    props.closeBypassModal()
  }

  return (
    <Modal
      id="modal-bypassrfi3-action"
      headingText="Factory Vetting Approval"
      isOpen={props.isVisible}
      onClose={() => clearAndCancelModal()}
      className="lcm-bypass-rfi3-modal"
    >
      <Grid.Container className="lcm-bypass-rfi3__content hc8-ph-6x hc8-pv-4x">
        <p className="lcm-bypass-rfi3__intro hc8-pv-2x hc8-mb-none hc8-lh-body">
          {getRfiTagValues('headingMessages')['rfi3FastTrackDisclaimer']}
        </p>
        <div className="lcm-bypass-rfi3__options hc8-pl-none hc8-pt-none hc8-pb-2x hc8-mt-none hc8-wth-100">
          <Input.Radios
            name="bypass-rfi3-options"
            data-testid="bypass-rfi3-options"
            id="bypass-rfi3-options"
            options={radioBtns}
            value={bypassRfi3 ? 'bypass' : 'continue'}
            onChange={(_event, { value }) => {
              setBypassRfi3(value === 'bypass')
            }}
          />

          {bypassRfi3 && (
            <>
              <div className="lcm-bypass-rfi3__comment-field hc8-wth-100">
                <Input.Label className="lcm-bypass-rfi3__comment-label hc8-mt-6x hc8-fs-100">
                  Please state your reason for Fast-Tracking RFI3 review.
                  mandatory field
                  <span className="hc8-clr-error"> *</span>
                  <strong className="lcm-bypass-rfi3__counter">{`${comments.length} / ${commentsMaxLen}`}</strong>
                </Input.Label>
              </div>

              <Input.Textarea
                data-testid="textarea-bypass-rfi3-comment"
                id="textarea-bypass-rfi3-comment"
                maxLength={commentsMaxLen}
                value={comments}
                placeholder="Add comments"
                isErrored={isCommentError()}
                onChange={(event) => setComments(event.target.value)}
              />
            </>
          )}
        </div>
        <div className="lcm-modal-actions lcm-bypass-rfi3__actions hc8-wth-100 hc8-pt-4x">
          <Button
            data-testid="btn-bypass-rfi3-cancel"
            className="lcm-bypass-rfi3__button hc8-mr-3x"
            variant="secondary"
            size="md"
            onClick={() => clearAndCancelModal()}
          >
            Cancel
          </Button>
          <Button
            data-testid="btn-bypass-rfi3-confirm"
            className="lcm-bypass-rfi3__button"
            variant="primary"
            size="md"
            isDisabled={bypassRfi3 && isCommentError()}
            onClick={() => props.updateBypassReaction(bypassRfi3, comments)}
          >
            Confirm
          </Button>
        </div>
      </Grid.Container>
    </Modal>
  )
}

export default BypassRFI3Modal
